export function checkAndExtractRoleAgency(array: any): string {
  // for (let s of array) {
  //   if (s.includes('role_agency_')) {
  //     // Find the position of "role_agency_" in the string
  //     const index = s.indexOf('role_agency_');
  //     // Extract the value after "role_agency_"
  //     return s.substring(index + 'role_agency_'.length);
  //   }
  // }

  // return '';

  const agencyRoles = array.filter((s: string) => s.startsWith('role_agency_'));
  if (agencyRoles.length === 1 && agencyRoles[0] === 'role_agency_branch') {
    return 'role_agency_branch';
  }

  for (let s of agencyRoles) {
    if (s !== 'role_agency_branch') {
      return s.substring('role_agency_'.length); // Trích phần sau "role_agency_"
    }
  }

  return '';
}
